import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight, Wallet } from "lucide-react";
import { Reveal } from "./Reveal";

const CLUB_URL = "https://digikart.fr/t/XCQtVT5_ESUw";

const CrocClub = () => {
  const reduce = useReducedMotion();

  return (
    <section id="croc-club" data-testid="crocclub-section" className="bg-brand-pink text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 md:py-24 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <Reveal>
          <p className="text-sm font-semibold uppercase tracking-widest text-white/80">
            CROC CLUB 🐷💗
          </p>
          <h2 className="mt-3 font-display font-bold tracking-tight text-3xl md:text-4xl lg:text-5xl">
            COME. CROCCA. REPITE.
          </h2>
          <p className="mt-4 text-base md:text-lg text-white/85 leading-relaxed max-w-xl">
            Cada visita cuenta. Acumula tus CROC y consigue un CROC GRATIS.
          </p>
          <p className="mt-4 flex items-start gap-3 text-sm md:text-base text-white/80 leading-relaxed max-w-xl">
            <Wallet className="w-5 h-5 mt-0.5 shrink-0" aria-hidden="true" />
            <span>
              No necesitas descargar ninguna app. Guarda tu tarjeta CROC CLUB en
              Apple Wallet o Google Wallet y llévala siempre contigo.
            </span>
          </p>
          <div className="mt-8">
            <a
              data-testid="crocclub-cta-button"
              href={CLUB_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-brand-charcoal text-white font-semibold uppercase tracking-wide rounded-full px-8 py-3.5 hover:bg-black hover:scale-105 transition-transform"
            >
              Únete al CROC CLUB
              <ArrowRight className="w-4 h-4" aria-hidden="true" />
            </a>
          </div>
        </Reveal>
        <Reveal delay={0.15} className="relative flex justify-center lg:justify-end">
          <div className="relative w-56 md:w-72 lg:w-80 aspect-square">
            <div className="absolute inset-0 bg-white/15 rounded-full" aria-hidden="true" />
            <div
              className={`absolute -inset-3 md:-inset-5 rounded-full border-2 border-dashed border-white/40 ${reduce ? "" : "animate-croc-spin"}`}
              aria-hidden="true"
            />
            <motion.img
              src="/brand/croc-mascot.png"
              alt="Mascota de CROC LAB"
              data-testid="crocclub-mascot-image"
              className="relative w-full h-auto rounded-full drop-shadow-xl"
              animate={reduce ? undefined : { y: [0, -12, 0] }}
              whileHover={reduce ? undefined : { rotate: -4, scale: 1.03 }}
              transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default CrocClub;
